import type { Organizer } from '@/types';
import styles from './AvatarComponent.module.scss';
import { VerifiedIcon } from '../../VerifiedIcon/VerifiedIcon';
import { UserIcon } from '../../UserIcon/UserIcon';
import { Avatar } from '@eventbrite/marmalade';
import { getImageProps } from 'next/image';

export interface AvatarComponentProps {
  organizer: Organizer;
  clickable?: boolean;
  onClick?: () => void;
  size?: 'small' | 'large';
}

export const AvatarComponent: React.FC<AvatarComponentProps> = ({
  organizer,
  clickable = false,
  onClick,
  size = 'large',
}) => {
  const avatarText = (organizer.name && organizer.name[0]) || '';

  const className = `${styles.avatarWithBadge} ${clickable ? styles.clickable : ''} ${styles[size]}`.trim();

  const {
    props: { src },
  } = getImageProps({
    alt: '',
    width: 52,
    height: 58,
    src: organizer.image || '',
  });

  return (
    <div className={className} onClick={() => clickable && onClick && onClick()}>
      <Avatar
        className={styles.customAvatar}
        text={avatarText}
        icon={<UserIcon />}
        imageSrc={src}
        imageAlt={organizer.name}
        placeholder={organizer.name}
      ></Avatar>
      {organizer.verified && (
        <div className={styles.verifiedBadge}>
          <VerifiedIcon />
        </div>
      )}
    </div>
  );
};
